import React from 'react';
import { BuildingIcon, CpuIcon, UserCogIcon, WrenchIcon, XIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { audiences } from '../../data/content';
const icons = [WrenchIcon, UserCogIcon, CpuIcon, BuildingIcon];
const notFor = ['It’s not a general introduction to automotive theory.', 'It’s not a list of parts to replace without testing.', 'It’s not a universal procedure that overrides manufacturer-specific diagnostic requirements.'];
export function Audience() {
  return <section className="w-full bg-ink py-16 sm:py-24" data-id="element-67" data-mp="1wn5g1ioszv47">
      <div className="mx-auto max-w-6xl px-4" data-id="element-68" data-mp="1wmdm0cauu5g1">
        <SectionHeading title={<>Built for automotive professionals who need a <span className="text-brand" data-id="element-70" data-mp="21kf4av0gi0qg">practical diagnostic process</span></>} data-id="element-69" data-mp="21m88m3nlk8va" />

        <div className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-71" data-mp="l76x8n3tpups">
          {audiences.map((a, i) => {
          const Icon = icons[i];
          return <div key={a.title} className="flex gap-4" data-id="element-72" data-mp="zlrvbcw28urg" data-mpi={i}>
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-brand" data-id="element-73" data-mp="zoe41fuotgb9">
                  <Icon className="h-7 w-7 text-ink" aria-hidden="true" data-id="element-74" data-mp="upkzwe1aj1nr" />
                </span>
                <div data-id="element-75" data-mp="19i4o88js74l5">
                  <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-white" data-id="element-76" data-mp="14lnyj9wxoi5y">{a.title}</h3>
                  <p className="mt-1 text-base leading-relaxed text-body" data-id="element-77" data-mp="1ikdzx1qsd404">{a.text}</p>
                </div>
              </div>;
        })}
        </div>

        <div className="mx-auto mt-14 max-w-3xl rounded-3xl border-2 border-alert bg-alert-soft p-6 sm:p-8" data-id="element-78" data-mp="1saz372hemwpd">
          <h3 className="font-display text-3xl font-black uppercase text-white" data-id="element-79" data-mp="1nc5qvddutbqs">This system is not for everyone.</h3>
          <ul className="mt-4 space-y-2.5" data-id="element-80" data-mp="21avnyt0obbf5">
            {notFor.map(n => <li key={n} className="flex items-start gap-2.5 text-base text-white" data-id="element-81" data-mp="1xabrzsru6dul">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-82" data-mp="24d9vyl785gpn" />
                {n}
              </li>)}
          </ul>
          <p className="mt-5 text-lg font-semibold text-brand" data-id="element-83" data-mp="29cmg2y6po9oj">
            It’s a practical diagnostic organization system for technicians who want a more structured way to investigate no-start
            complaints.
          </p>
        </div>

        <CtaButton className="mt-12" label="This Is for Me — Get Access" data-id="element-84" data-mp="2n49dx2gaxq9f" />
      </div>
    </section>;
}